import { gql, useQuery } from '@apollo/client';
import { default as GetInTheNewsQuery } from "./entries.gql";
import { InsertLinkFieldSimpleFragment } from '@graphql/_fragments/fields/InsertLink/simple';
import type { GetInTheNewsProps, GetInTheNewsResponse, GetInTheNewsVariables } from "./entries.types";

const useGetInTheNewsQuery = ({preview, refetch, ...variables}: GetInTheNewsProps) => {
  const query = gql`${GetInTheNewsQuery}${InsertLinkFieldSimpleFragment}`;
  const response = useQuery<GetInTheNewsResponse, GetInTheNewsVariables>(query, {
    variables,
  });
  if(!!refetch)
    response.refetch();
  return response;
};

export default useGetInTheNewsQuery;